module.exports = __webpack_public_path__ + "static/media/ehealth-bg3-preview.667cd40d.jpg";